import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Bud, faktura og kreditnotaer til tidslinjen for ett oppdrag. Spørringene filtrerer på brukerens
// egen uid i tillegg til orderId, slik at sikkerhetsreglene kan bevise at alle treff er lesbare:
// sjåføren får bare sitt eget bud og sine egne fakturaer, bestilleren sine fakturaer (reglene
// slipper bestilleren inn på budene via ordren).
export function useOrderTimelineData(orderId, role, enabled = true) {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const [bids, setBids] = useState([]);
  const [invoice, setInvoice] = useState(null);
  const [creditNotes, setCreditNotes] = useState([]);
  const [bidsLoading, setBidsLoading] = useState(true);
  const [invoicesLoading, setInvoicesLoading] = useState(true);

  useEffect(() => {
    if (!enabled || !orderId || !uid) return undefined;
    setBidsLoading(true);
    setInvoicesLoading(true);

    const driver = role === 'driver';
    const bidQuery = driver
      ? query(collection(db, 'bids'), where('orderId', '==', orderId), where('driverUid', '==', uid))
      : query(collection(db, 'bids'), where('orderId', '==', orderId));
    const invoiceQuery = query(
      collection(db, 'invoices'),
      where('orderId', '==', orderId),
      where(driver ? 'driverUid' : 'ordererUid', '==', uid),
    );

    const unsubBids = onSnapshot(bidQuery, (snap) => {
      setBids(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setBidsLoading(false);
    }, (err) => {
      console.error('useOrderTimelineData (bud):', err);
      setBids([]);
      setBidsLoading(false);
    });

    const unsubInvoices = onSnapshot(invoiceQuery, (snap) => {
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setInvoice(docs.find(i => !i.kind) ?? docs.find(i => i.kind === 'driver-to-orderer') ?? null);
      setCreditNotes(docs.filter(i => i.kind === 'credit-note'));
      setInvoicesLoading(false);
    }, (err) => {
      console.error('useOrderTimelineData (faktura):', err);
      setInvoice(null);
      setCreditNotes([]);
      setInvoicesLoading(false);
    });

    return () => { unsubBids(); unsubInvoices(); };
  }, [orderId, role, uid, enabled]);

  return { bids, invoice, creditNotes, loading: enabled && (bidsLoading || invoicesLoading) };
}
